// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gBAxy","scrollbars":"styles_scrollbars__R9R7r","slideInSearchBar":"styles_slideInSearchBar__dttKV"};